import React, { Component, ReactNode } from 'react';
import classNames from 'classnames';
// import RetinaImage from 'react-retina-image';
import styles from './FeaturedItem.module.scss';

interface IFeaturedItem {
	image: Array<string>;
	children?: ReactNode;
	color?: string;
	size?: string;
	align?: string;
	location?: string;
	tilt?: boolean;
	imageClassName?: string;
	className?: string;
}

export default class FeaturedItem extends Component<IFeaturedItem> {
	static color = {
		DIMMED: 'Dimmed',
		PRIMARY: 'Primary',
		HIDDEN: 'Hiden',
	};

	static location = {
		BOTTOM_LEFT: 'BottomLeft',
		BOTTOM_RIGHT: 'BottomRight',
		TOP_LEFT: 'TopLeft',
		TOP_RIGHT: 'TopRight',
	};

	static size = {
		WIDE: 'Wide',
		NARROW: 'Narrow',
	};

	static align = {
		LEFT: 'Left',
		CENTER: 'Center',
		RIGHT: 'Right',
	};

	render() {
		const {
			color = '',
			image = '',
			tilt = 'true',
			align = 'LEFT',
			location = 'BottomLeft',
			size = 'Wide',
		} = this.props;

		const itemClasses = classNames(styles.featuredItem, this.props.className || '', {
			[styles['featuredItem' + align]]: align,
			[styles.tilt]: tilt,
		});

		const contentClasses = classNames(styles.contentBox, {
			[styles['contentBox' + color]]: color,
			[styles['contentBox' + location]]: location,
			[styles['contentBox' + size]]: size,
		});

		const imgClassName = classNames(styles.image, this.props.imageClassName);

		return (
			<div className={itemClasses}>
				<div className={styles.inner}>
					<div className={styles.imageContainer}>
						<img src={image[0]} className={imgClassName} alt="Museum" />
						{/* <RetinaImage /> */}
					</div>
					<div className={contentClasses}>{this.props.children}</div>
				</div>
			</div>
		);
	}
}
